import { z } from 'zod'

export type FileOrUrl = z.infer<typeof FileOrUrl>
export const FileOrUrl = z.union([z.instanceof(File), z.string()])
